module.exports = __webpack_public_path__ + "img/detail-7.ec6fa4c8.png";